import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { errorToast } from "../../../utils/toast";
import moment from "moment";
import { Button, useDisclosure } from "@chakra-ui/react";
import SendPendingMessageModal from "./SendPendingMessageModal";

const UpiOrders = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [messageStartDate, setMessageStartDate] = useState("");
const [messageEndDate, setMessageEndDate] = useState("");
  const {
  isOpen: isMessageOpen,
  onOpen: onMessageOpen,
  onClose: onMessageClose,
} = useDisclosure();

const {
  isOpen: isSingleMessageOpen,
  onOpen: onSingleMessageOpen,
  onClose: onSingleMessageClose,
} = useDisclosure();

const [selectedOrder, setSelectedOrder] = useState(null);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("page", page);
      params.append("limit", 10);
      if (searchQuery) params.append("query", searchQuery);
      if (activeTab !== "all") params.append("status", activeTab);

      const { data } = await axios.get(`/admin/upi-orders?${params.toString()}`);

      if (data?.result) {
        setOrders(data.result.upiOrders || []);
        setTotalPages(data.result.pagination?.totalPagesCount || 1);
        setTotalCount(data.result.pagination?.totalCount || 0);
      }
    } catch (error) {
      console.error("Error fetching UPI orders:", error);
      errorToast(error.response?.data?.message || "Failed to fetch UPI orders");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [activeTab, page, searchQuery]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };

  const pendingCount = orders.filter((o) => o.status === "pending").length;
  const successCount = orders.filter((o) => o.status === "success").length;
  const sendPendingUsersMessage = async () => {
  try {
    const userIds = orders
      .filter(order => order.status === "pending")
      .map(order => order.user?._id)
      .filter(Boolean);

    if (!userIds.length) {
      return errorToast("No pending users found");
    }

    const res = await axios.post(
      "/sendPendingUpiUsersMessage",
      {
        userIds,
      }
    );

    alert(res.data.message);
  } catch (err) {
    errorToast(
      err?.response?.data?.message ||
      "Failed to send message"
    );
  }
};

  return (
    <div className="p-6 pt-10 bg-gray-50 min-h-screen">
     <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
  <div>
    <h1 className="text-2xl font-bold text-gray-800">
      UPI Orders
    </h1>
    <p className="text-sm text-gray-500 mt-1">
      Course purchase orders via UPI gateway
    </p>
  </div>

  <div className="flex items-center gap-3">
      <Button
    colorScheme="green"
    onClick={onMessageOpen}
  >
    Send Pending Message
  </Button>
<SendPendingMessageModal
  drawer
  isOpen={isMessageOpen}
  onClose={onMessageClose}
  endpoint="/sendPendingUpiUsersMessage"
  title="Send Pending UPI Message"
  payload={{
    startDate: messageStartDate,
    endDate: messageEndDate,
  }}
>
  <label>From Date</label>
  <input
    type="date"
    className="w-full border rounded p-2 mb-4"
    value={messageStartDate}
    onChange={(e) => setMessageStartDate(e.target.value)}
  />

  <label>To Date</label>
  <input
    type="date"
    className="w-full border rounded p-2"
    value={messageEndDate}
    onChange={(e) => setMessageEndDate(e.target.value)}
  />
</SendPendingMessageModal>
    <div className="text-gray-600 font-medium">
      Total:
      <span className="text-purple font-bold ml-1">
        {totalCount}
      </span>
    </div>
  </div>
</div>

      {/* Tabs */}
      <div className="flex mb-6 bg-white rounded-lg p-1 shadow-sm w-fit gap-1">
        <button
          className={`px-5 py-2 rounded-md font-medium transition-colors ${
            activeTab === "all"
              ? "bg-purple text-white"
              : "text-gray-600 hover:bg-gray-100"
          }`}
          onClick={() => { setActiveTab("all"); setPage(1); }}
        >
          All Orders
        </button>
        <button
          className={`px-5 py-2 rounded-md font-medium transition-colors ${
            activeTab === "pending"
              ? "bg-yellow-500 text-white"
              : "text-gray-600 hover:bg-gray-100"
          }`}
          onClick={() => { setActiveTab("pending"); setPage(1); }}
        >
          Pending
        </button>
        <button
          className={`px-5 py-2 rounded-md font-medium transition-colors ${
            activeTab === "success"
              ? "bg-green-600 text-white"
              : "text-gray-600 hover:bg-gray-100"
          }`}
          onClick={() => { setActiveTab("success"); setPage(1); }}
        >
          Success
        </button>
      </div>
      

      {/* Search */}
      <div className="mb-4">
        <input
          type="text"
          placeholder="Search by Order ID, User Name, Email, Mobile..."
          className="px-4 py-2 border rounded-lg w-80 focus:outline-none focus:ring-2 focus:ring-purple-500"
          value={searchQuery}
          onChange={handleSearch}
        />
      </div>

      {/* Table */}
      <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-600">
            <thead className="bg-gray-50 text-gray-700 font-semibold uppercase text-xs border-b">
              <tr>
                <th className="p-4">#</th>
                <th className="p-4">Date</th>
                <th className="p-4">User</th>
                <th className="p-4">Order ID</th>
                <th className="p-4">Course</th>
                <th className="p-4">Amount</th>
                <th className="p-4">Status</th>
                <th className="p-4">Send Message</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {loading ? (
                <tr>
                  <td colSpan="8" className="p-8 text-center text-gray-500">
                    Loading...
                  </td>
                </tr>
              ) : orders.length === 0 ? (
                <tr>
                  <td colSpan="8" className="p-8 text-center text-gray-500">
                    No UPI orders found
                  </td>
                </tr>
              ) : (
                orders.map((order, index) => (
                  <tr
                    key={order._id}
                    className="hover:bg-gray-50 transition-colors"
                  >
                    <td className="p-4 text-gray-400">
                      {(page - 1) * 10 + index + 1}
                    </td>
                    <td className="p-4 whitespace-nowrap">
                      <div>{moment(order.createdOn).format("DD MMM YYYY")}</div>
                      <div className="text-xs text-gray-400">
                        {moment(order.createdOn).format("hh:mm A")}
                      </div>
                    </td>
                    <td className="p-4">
                      {order.user?._id ? (
                        <Link
                          to={`/dash/view-user/${order.user._id}`}
                          className="font-medium text-gray-900 hover:underline"
                        >
                          {order.user?.name || "N/A"}
                        </Link>
                      ) : (
                        <div className="font-medium text-gray-900">
                          {order.user?.name || "N/A"}
                        </div>
                      )}
                      <div className="text-xs">{order.user?.email || ""}</div>
                      <div className="text-xs">{order.user?.mobile || ""}</div>
                    </td>
                    <td className="p-4 font-mono text-xs">{order.orderId}</td>
                    <td className="p-4">
                      {order.course?.planName || order.planName || "N/A"}
                    </td>
                    <td className="p-4 font-bold text-gray-800">
                      ₹{order.amount}
                    </td>
                    <td className="p-4">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold ${
                          order.status === "success"
                            ? "bg-green-100 text-green-700"
                            : "bg-yellow-100 text-yellow-700"
                        }`}
                      >
                        {order.status}
                      </span>
                    </td>
                    <td className="p-4">
  <Button
    size="sm"
    colorScheme="green"
    onClick={() => {
      setSelectedOrder(order);
      onSingleMessageOpen();
    }}
  >
    Send Message
  </Button>
</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="p-4 border-t flex justify-between items-center bg-gray-50">
            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="px-4 py-2 border rounded-lg bg-white disabled:opacity-50 hover:bg-gray-100 text-sm font-medium"
            >
              Previous
            </button>
            <span className="text-sm font-medium text-gray-600">
              Page {page} of {totalPages}
            </span>
            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="px-4 py-2 border rounded-lg bg-white disabled:opacity-50 hover:bg-gray-100 text-sm font-medium"
            >
              Next
            </button>
          </div>
        )}
      </div>
      <SendPendingMessageModal
  isOpen={isSingleMessageOpen}
  onClose={onSingleMessageClose}
  endpoint="/sendPendingUpiSingleUserMessage"
  title="Send UPI Reminder"
  description={`Send WhatsApp message to ${selectedOrder?.user?.name}?`}
  payload={{
    orderId: selectedOrder?._id,
  }}
  onSuccess={fetchOrders}
/>
    </div>
    
  );
};

export default UpiOrders;
